import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Box, Typography, Checkbox } from '@mui/material'
import OneModal from "../../../../../Components/OneModal/OneModal"
import OneButton from '../../../../../Components/OneButton/OneButton'

const CopiarPerguntas = ({ open, setOpen, title, listaPerguntas, setCheckedPerguntas, handleSalvarPerguntas }) => {
    const handleFechar = () => {
        setOpen(false)
        handleSalvarPerguntas()
    }

    const handleChecked = (index, pergunta) => {
        setCheckedPerguntas(prev => {
            const newCheckedPerguntas = {
                ...prev,
                [index]: pergunta
            }

            return Object.values(newCheckedPerguntas).flatMap((pergunta) => pergunta.split(', '))
        })
    }

    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText={title}
        >
            <Grid container sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <Box size="small" aria-label="a dense table">
                    {listaPerguntas.map((pergunta, index) => (
                        <Typography key={index}>
                            <Checkbox onChange={() => handleChecked(index, pergunta.perguntas_ronda)}/>
                            {pergunta.perguntas_ronda}
                        </Typography>
                    ))}
                </Box>
                <OneButton variant="contained" color="success" onClick={handleFechar}>Salvar</OneButton>
            </Grid>
        </OneModal>
    )
}

export default CopiarPerguntas
